// eslint-disable-next-line import/no-dynamic-require
const env = require(`./env.${process.env.NODE_ENV}`)
export default env.default



// WEBPACK FOOTER //
// ./src/config/index.js